<template>
    <div class="contentWrap activityRewardWrap">
        <div class="activityRewardWrap_content">
           <div class="activityRewardWrap_contentHide">
                <div class="activityRewardCon_item sectPatriarch" ref="sectPatriarch">
                    <div >
                          <!-- <span ></span> -->
                          <!-- require('../assets/scord_bright.png'):require('../assets/scord.png') -->
                          <img @click="accordion(1)" @mouseover="hoverOver(1,'scord_bright.png')" @mouseout="hoverOver(1,'scord.png')" :src="scordUlrl"  alt="">
                    <div>
                    <img src="../assets/reward_text.png" alt="">
                    <div class="strategyBox" v-if="strategyState">
                        <img src="../assets/X.png" @click="strategyState = false" alt="">
                        <ul>
                            <li>
                                <span>5月7日~5月20日19：00</span>
                                <p>广招宗门仙师积攒宗门实力</br>微信群与宗门好友畅聊新服蓝图</p>
                            </li>
                            <li>
                                <span>5月20日19:00</span>
                                <p>带领宗门成员登录新服</p>
                            </li>
                            <li>
                                <span>5月20日19:00~5月26日23:59</span>
                                <p>完成指定任务：带领宗门</br>成员完成修仙盟通告卷任务</p>
                            </li>
                            <li>
                                <span>5月27日</span>
                                <p>按照宗门27日结算时，当天登录且</br>完成任务的成员数进行排名发奖</p>
                            </li>
                        </ul>
                          <p style="color: #badcdd;padding: 30px 0px;clear: both;font-size:13px;text-align:center;color:white;"> <span style="color:red;">温馨提示</span> ：活动结束后，活动结束后，前三名宗门完成任务的所有成员将获得宗门专属服饰,时装样式将于近期公布至QQ群（549867266）请各位仙友加群关注</p>
                    </div>
                    <div class="rewind">
                        <ul v-for="(item,index) in tableData" :key="index">
                            <li @mouseover="mouseoverIcon(index,childrenindex)" @mouseout="mouseoutIcon(index,childrenindex)"  v-for="(childrenitem,childrenindex) in item" :key="childrenindex">
                                <p>
                                      <img :src="childrenitem.icon" alt="">
                                      <em>{{childrenitem.name}}</em>
                                </p>
                              
                                <span v-if="childrenitem.info"><img :src="childrenitem.tips" alt=""></span>
                            </li>
                        </ul>    
                        <div>
                            <img @click="strategyState = true" src="../assets/seeReword.png" alt="">
                        </div>
                        
                    </div>
                </div>
                    </div>
                </div>
           <div class="rewardbox activityRewardCon_item">
                 <div>
                     <!-- <span @click="accordion(2)"></span> -->
                     <!-- require('../assets/sectReword_broght.png'):require('../assets/sectReword.png') -->
                     <img @click="accordion(2)"  @mouseover="hoverOver(2,'sectReword_broght.png')" @mouseout="hoverOver(2,'sectReword.png')"  :src="sectUrl" alt="">
                     <div>
                             <div class="reward">
                                <ul>
                                    <li @mouseover="mouseoverrewardIcon(index)" @mouseout="mouseoutrewardIcon(index)" v-for="(item,index) in sectPrize" :key="index">
                                         <p>
                                            <img :src="item.icon" alt="">
                                            <em>{{item.name}}</em>
                                        </p> 
                                        <span v-if="item.info"><img :src="item.tips" alt=""></span>
                                    </li>
                                </ul>
                            </div>   
                            <div class="reward">
                                <ul>
                                    <li @mouseover="mouseovertaskIcon(index)" @mouseout="mouseouttaskIcon(index)" v-for="(item,index) in taskData" :key="index">
                                          <p>
                                            <img :src="item.icon" alt="">
                                            <em>{{item.name}}</em>
                                        </p> 
                                        <span v-if="item.info"><img :src="item.tips" alt=""></span>
                                    </li>
                                </ul>
                            </div>   
                            <img src="../assets/rewardpoints.png" alt="">
                            <div class="process_box">
                                <img src="../assets/technologicalProcess.png" alt="">
                                <ul>
                                    <li>
                                        <span>5月7日~5月20日19：00</span>
                                        <p>找到自己心仪的宗门</br>加入获得宗门加入礼包码</p>
                                    </li>
                                    <li>
                                        <span>5月20日19:00</span>
                                        <p>开服当天登录</br>激活礼包码，获得任务卷轴</p>
                                    </li>
                                    <li>
                                        <span>5月20日19:00~5月26日23:59</span>
                                        <p>完成任务即得奖励：加入任意宗门</br>参与宗门活动战力达到30000</p>
                                    </li>
                                </ul>
                              
                            </div>
                     </div>
                        
                    </div>
                 </div>
           </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            accordionType:0,
            scordUlrl:require('../assets/scord_bright.png'),
            sectUrl:require('../assets/sectReword.png'),
            strategyState:false,
            taskData:[
                    {
                        name:'装备强化石箱子*50',
                        icon:require('../assets/reward/1003qhs.png'),
                        tips:require('../assets/reward/1003qhs2.png'),
                        info:false
                    },
                    {
                        name:'天女丝囊*50',
                        icon:require('../assets/reward/1055tnsn.png'),
                        tips:require('../assets/reward/1055tnsn2.png'),
                        info:false
                    },
                    {
                        name:'高级鉴定符*20',
                        icon:require('../assets/reward/1072gjjdf.png'),
                        tips:require('../assets/reward/1072gjjdf2.png'),
                        info:false
                    },
                    {
                        name:'碎银100w',
                        icon:require('../assets/reward/292sy.png'),
                        tips:require('../assets/reward/292sy2.png'),
                        info:false
                    },
                    {
                        name:'庇佑符*5',
                        icon:require('../assets/reward/1050byf.png'),
                        tips:require('../assets/reward/1050byf2.png'),
                        info:false
                    },
            ],
            sectPrize:[
   {
                        name:'天女丝囊*5',
                        icon:require('../assets/reward/1055tnsn.png'),
                        tips:require('../assets/reward/1055tnsn2.png'),
                        info:false
                    },
                    {
                        name:'装备强化石箱子*20',
                        icon:require('../assets/reward/1001qhs.png'),
                        tips:require('../assets/reward/1001qhs2.png'),
                        info:false
                    },
                    {
                        name:'鉴定符*5',
                        icon:require('../assets/reward/1071jdf.png'),
                        tips:require('../assets/reward/1071jdf2.png'),
                        info:false
                    },
                    {
                        name:'紫金珠*5',
                        icon:require('../assets/reward/1309zjz.png'),
                        tips:require('../assets/reward/1309zjz2.png'),
                        info:false
                    },
                    {
                        name:'修仙盟任务卷*1',
                        icon:require('../assets/reward/21000xxmtgjz.png'),
                        tips:require('../assets/reward/21000xxmtgjz2.png'),
                        info:false
                    },
            ],
            tableData:[
                   // 第一名
                      // 第一名
                [
                    {
                        name:'幻澜翼兽*1',
                        icon:require('../assets/reward/55248hlys.png'),
                        tips:require('../assets/reward/55248hlys2.gif'),
                        info:false
                    },
                    {
                        name:'强化石宝箱*50',
                        icon:require('../assets/reward/1001qhs.png'),
                        tips:require('../assets/reward/1001qhs2.png'),
                        info:false
                    },
                    {
                        name:'幻化符*10',
                        icon:require('../assets/reward/101qhs.png'),
                        tips:require('../assets/reward/101qhs2.png'),
                        info:false
                    },
                    {
                        name:'高级鉴定符*10',
                        icon:require('../assets/reward/1072gjjdf.png'),
                        tips:require('../assets/reward/1072gjjdf2.png'),
                        info:false
                    },
                    {
                        name:'神兵结晶*8',
                        icon:require('../assets/reward/17000sbjj.png'),
                        tips:require('../assets/reward/17000sbjj2.png'),
                        info:false
                    },
                    {
                        name:'碎银200w',
                        icon:require('../assets/reward/293bwsy.png'),
                        tips:require('../assets/reward/293bwsy2.png'),
                        info:false
                    },
                    {
                        name:'庇佑符*10',
                        icon:require('../assets/reward/1050byf.png'),
                        tips:require('../assets/reward/1050byf2.png'),
                        info:false
                    },
                ],
  // 第二名
                  [
              {
                        name:'炽焰*1',
                        icon:require('../assets/reward/55247zy.png'),
                        tips:require('../assets/reward/55247zy2.gif'),
                        info:false
                    },
              {
                        name:'强化石宝箱*45',
                        icon:require('../assets/reward/1001qhs.png'),
                        tips:require('../assets/reward/1001qhs2.png'),
                        info:false
                    },
     {
                        name:'幻化符*10',
                        icon:require('../assets/reward/101qhs.png'),
                        tips:require('../assets/reward/101qhs2.png'),
                        info:false
                    },
                    {
                        name:'神兵结晶*6',
                        icon:require('../assets/reward/17000sbjj.png'),
                        tips:require('../assets/reward/17000sbjj2.png'),
                        info:false
                    },

                    {
                        name:'高级鉴定符*10',
                        icon:require('../assets/reward/1072gjjdf.png'),
                        tips:require('../assets/reward/1072gjjdf2.png'),
                        info:false
                    },
                    {
                        name:'碎银200w',
                        icon:require('../assets/reward/293bwsy.png'),
                        tips:require('../assets/reward/293bwsy2.png'),
                        info:false
                    },
                    {
                        name:'庇佑符*8',
                        icon:require('../assets/reward/1050byf.png'),
                        tips:require('../assets/reward/1050byf2.png'),
                        info:false
                    },
],
  // 第三名
                  [
              {
                        name:'天穹*1',
                        icon:require('../assets/reward/55250tq.png'),
                        tips:require('../assets/reward/55250tq2.gif'),
                        info:false
                    },
              {
                        name:'强化石宝箱*40',
                        icon:require('../assets/reward/1001qhs.png'),
                        tips:require('../assets/reward/1001qhs2.png'),
                        info:false
                    },
    {
                        name:'幻化符*10',
                        icon:require('../assets/reward/101qhs.png'),
                        tips:require('../assets/reward/101qhs2.png'),
                        info:false
                    },
                    {
                        name:'神兵结晶*4',
                        icon:require('../assets/reward/17000sbjj.png'),
                        tips:require('../assets/reward/17000sbjj2.png'),
                        info:false
                    },
                    {
                        name:'高级鉴定符*10',
                        icon:require('../assets/reward/1072gjjdf.png'),
                        tips:require('../assets/reward/1072gjjdf2.png'),
                        info:false
                    },
                    {
                        name:'碎银200w',
                        icon:require('../assets/reward/293bwsy.png'),
                        tips:require('../assets/reward/293bwsy2.png'),
                        info:false
                    },
                    {
                        name:'庇佑符*5',
                        icon:require('../assets/reward/1050byf.png'),
                        tips:require('../assets/reward/1050byf2.png'),
                        info:false
                    },
],
                      // 第四名
                  [
                    {
                        name:'强化石宝箱*35',
                        icon:require('../assets/reward/1001qhs.png'),
                        tips:require('../assets/reward/1001qhs2.png'),
                        info:false
                    },
              {
                        name:'幻化符*10',
                        icon:require('../assets/reward/101qhs.png'),
                        tips:require('../assets/reward/101qhs2.png'),
                        info:false
                    },
                    {
                        name:'神兵结晶*3',
                        icon:require('../assets/reward/17000sbjj.png'),
                        tips:require('../assets/reward/17000sbjj2.png'),
                        info:false
                    },
                    {
                        name:'高级鉴定符*10',
                        icon:require('../assets/reward/1072gjjdf.png'),
                        tips:require('../assets/reward/1072gjjdf2.png'),
                        info:false
                    },
                    {
                        name:'碎银100w',
                        icon:require('../assets/reward/293bwsy.png'),
                        tips:require('../assets/reward/293bwsy2.png'),
                        info:false
                    },
                    {
                        name:'庇佑符*3',
                        icon:require('../assets/reward/1050byf.png'),
                        tips:require('../assets/reward/1050byf2.png'),
                        info:false
                    },
],
  // 第五名
                  [
                    {
                        name:'强化石宝箱*30',
                        icon:require('../assets/reward/1001qhs.png'),
                        tips:require('../assets/reward/1001qhs2.png'),
                        info:false
                    },
              {
                        name:'幻化符*10',
                        icon:require('../assets/reward/101qhs.png'),
                        tips:require('../assets/reward/101qhs2.png'),
                        info:false
                    },
                    {
                        name:'神兵结晶*2',
                        icon:require('../assets/reward/17000sbjj.png'),
                        tips:require('../assets/reward/17000sbjj2.png'),
                        info:false
                    },
                    {
                        name:'高级鉴定符*10',
                        icon:require('../assets/reward/1072gjjdf.png'),
                        tips:require('../assets/reward/1072gjjdf2.png'),
                        info:false
                    },
                    {
                        name:'碎银100w',
                        icon:require('../assets/reward/293bwsy.png'),
                        tips:require('../assets/reward/293bwsy2.png'),
                        info:false
                    },
                    {
                        name:'庇佑符*2',
                        icon:require('../assets/reward/1050byf.png'),
                        tips:require('../assets/reward/1050byf2.png'),
                        info:false
                    },
],
  // 第六~十名
                  [
                    {
                        name:'强化石宝箱*25',
                        icon:require('../assets/reward/1001qhs.png'),
                        tips:require('../assets/reward/1001qhs2.png'),
                        info:false
                    },
              {
                        name:'幻化符10',
                        icon:require('../assets/reward/101qhs.png'),
                        tips:require('../assets/reward/101qhs2.png'),
                        info:false
                    },
                    {
                        name:'高级鉴定符*10',
                        icon:require('../assets/reward/1072gjjdf.png'),
                        tips:require('../assets/reward/1072gjjdf2.png'),
                        info:false
                    },
                    {
                        name:'碎银100w',
                        icon:require('../assets/reward/293bwsy.png'),
                        tips:require('../assets/reward/293bwsy2.png'),
                        info:false
                    },
                    {
                        name:'庇佑符*1',
                        icon:require('../assets/reward/1050byf.png'),
                        tips:require('../assets/reward/1050byf2.png'),
                        info:false
                    },
],
            ]
        }
    },
    mounted(){
        if(document.body.offsetWidth<1920){
            document.getElementsByClassName('activityRewardWrap_content')[0].style.transform = 'scale(.9)'
        }
    },
    methods:{
        accordion(type){
            if(type == 1){
                this.$refs.sectPatriarch.style.width = '1106px'
                this.accordionType = 0
                this.scordUlrl = require('../assets/scord_bright.png')
                this.sectUrl = require('../assets/sectReword.png')
            }else{
                this.$refs.sectPatriarch.style.width = '96px'
                this.accordionType = 1
                this.scordUlrl = require('../assets/scord.png')
                this.sectUrl = require('../assets/sectReword_broght.png')
            
            }
            
        },
        hoverOver(type,url){
            if(type== 1){
                if(this.accordionType !=0){
                     this.scordUlrl = require('@/assets/'+url)
                }
               
            }else{
                if(this.accordionType !=1){
                         this.sectUrl = require('@/assets/'+url)
                }
           
            }
        },
        mouseoverrewardIcon(index){
            this.sectPrize[index].info = true
        },
        mouseoutrewardIcon(index){
            this.sectPrize[index].info = false
        },
        mouseovertaskIcon(index){
            this.taskData[index].info = true
        },
        mouseouttaskIcon(index){
            this.taskData[index].info = false
        },
        mouseoverIcon(index,childrenindex){
            this.tableData[index][childrenindex].info = true
        },
        mouseoutIcon(index,childrenindex){
            this.tableData[index][childrenindex].info = false
        }
    },

}
</script>
<style lang="less">
.activityRewardWrap{
    .activityRewardWrap_content{
        height:800px;
        width:1200px;
        // background:url(../assets/prizeItem_bg.png);
        background:rgba(0,0,0,.6);
        overflow: hidden;
        position: absolute;
        top:0px;
        right:0px;
        bottom:0px;
        left:0px;
        margin:auto;
        .activityRewardWrap_contentHide{
            width:2400px;
        }
        .rewardbox{
            >div>img{
                float:left;
            }
      
        >div>div{
            padding-top:62px;
            box-sizing: border-box;
            >img{
                width:284px;
                height:36px;
                margin:0px auto;
                display: block;
                margin-top:30px;
            }
        }
        .process_box{
            padding-top:30px;
            padding-left:60px;
            >img{
                padding-left:28px;
            }
            ul{
                li+li{
                    width:328px;
                    margin-left:63px;
                }
                li+li+li{
                    width:300px;
                    margin-left:0px;
                }
                li{
                    float:left;
                    width:163px;
                    text-align: center;
                    span{
                        color: rgba(252, 245, 198, 1);
                        font-size: 14px;
                        padding-top:4px;
                    }
                    p{
                        color: rgba(186, 220, 221, 1);
                        font-size:14px;
                        padding-top:16px;
                    }
                }
            }
        }
        .reward+.reward{
              background:url('../assets/reward_bg1.png');
        }
            .reward{
               width:874px;
               height:127px;
               margin:0px auto;
               margin-top:17px;
               background:url('../assets/reward_bg.png');
               >ul{
                   padding:20px 0px 0px 321px;
                      li{
                            float:left;
                            position: relative;
                            margin-left:36px;
                            >p{
                                width: 68px;
	                            // height: 68px;
                                	font-size: 12px;
                                    color: rgba(247, 231, 183, 1);
                                    text-align: center;
                                img{
                                      width: 68px;
                                      height: 68px;
                                }
                                em{
                                    font-style:normal;
                                    margin-top:-4px;
                                    display: block;
                                }
                            }
                              span{
                                width: 246px;
                                position: absolute;
                                top:0px;
                                left:-249px;
                                background:rgb(201,102,22);
                                border:1px solid rgb(253,150,66);
                                box-sizing: border-box;
                                z-index: 99;
	                            // height: 165px;
                                padding:9px;
                                img{
                                 width: 228px;
                                    // height: 149px;
                                }
                            }
                          
                        }
               }
           }
          
       
        }
        .activityRewardCon_item{
                float:left;
                 overflow: hidden;
                 width:1106px;
                 transition: all .8s ease-in-out;
                   >div{
                        width:1106px;
                         >img{
                        float :left;
              }  
              >div{
                  width: 996px;
                  background-size:100%;
	              height: 786px;
                  float:left;
                  margin:6px 8px;
                  background:url(../assets/jiao.png);
                  background-size:100%;
              }
                    }
               
               
        }
        .sectPatriarch{
            float:left;
            width:1106px;
            overflow: hidden;
            >div{
                width:1106px;
            }
            >div>img{
       
                float:left;
            }
            .strategyBox{
                width: 986px;
            	height: 483px;
                background:url(../assets/Strategy.png);
                position: absolute;
                top:0px;
                left:0px;
                right:0px;
                bottom:0px;
                margin:auto;
                z-index: 99;
                >img{
                    float:right;
                    padding:12px 16px;
                }
                ul{
                    padding-top:320px;
                    li{
                        float:left;
                        width:226px;
                        text-align: center;
                        span{
                           color: rgba(252, 245, 198, 1); 
                        }
                        p{
                          padding-top:22px;
                          color: rgba(186, 220, 221, 1);  
                        }
                    }
                }
            }
            >div>div{
                // margin-left:29px;
                float:left;
                // padding-right:28px;
                >img{
                    padding-top:48px;
                    padding-left:222px;   
                }
                >.rewind{
                    background:url('../assets/rewardScord_bg.png');
                    width:955px;
                    height:607px;
                    margin-top:17px;
                    margin-left:21px;
                    >div{
                        text-align: center;
                        padding-top:13px;
                    }
                    ul+ul{
                        padding-top:7px;
                    }
                    ul{
                        padding-top:7px;
                        clear: both;
                        margin-left:158px;
                        height: 95px;
                        li+li{
                            margin-left:15.5px;
                        }
                        li{
                            float:left;
                            position: relative;
                            
                            >p{
                                width: 94px;
	                            // height: 68px;
                                	font-size: 12px;
                                    color: rgba(247, 231, 183, 1);
                                    text-align: center;
                                img{
                                      width: 68px;
	                            height: 68px;
                                	

                                }
                                em{
                                    font-style:normal;
                                    margin-top:-4px;
                                    display: block;
                                }
                            }
                            span{
                                width: 246px;
                                position: absolute;
                                top:0px;
                                left:-236px;
                                background:rgb(201,102,22);
                                border:1px solid rgb(253,150,66);
                                box-sizing: border-box;
                                z-index: 99;
	                            // height: 165px;
                                padding:9px;
                                img{
                                 width: 228px;
                                    // height: 149px;
                                }
                            }
                          
                        }
                    }
                }
            }
        }
    }
}
</style>